import React, { Component } from 'react';
import { ACCESS_TOKEN, API_BASE_URL } from "../../constatns";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemText from "@material-ui/core/ListItemText";
import CountUp from "react-countup";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

class TournamentDetailLeaderboard extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {

    setTimeout(()=> {
      fetch(`${API_BASE_URL}/tournament/leaderboard?tournamentId=${this.props.data.id}`, {
        method: 'GET',
      }).then(res => res.text())
      .then(body => {
        let result = JSON.parse(body);
        const best = result.map((item, index) => {

          return (
            <div className="card" key={index}>
              <ListItem>
                <ListItemText>
                  <b>{(index+1) +' '}</b>{ '위'}
                </ListItemText>
                <ListItemAvatar>
                  <Avatar style={{width: '80px', height: '80px', marginRight: '10px'}}>
                    <img src={item.image_url} style={{width: '100%', height: '100%'}}/>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={item.username}
                  // secondary={'Length: '+item.lengthSum +', Weight: '+item.weightSum +', Catches: '+item.count}
                />
                <ListItemText>
                  <div className="media-body align-self-center row  text-center">
                    <div style={{borderRight:'1px solid #f6f7fb', paddingRight: '25px'}}>
                      <p style={{fontSize:'12px'}}>LENGTH </p>
                      <span className="counter">
                      <CountUp className="counter" end={item.lengthSum} /></span>
                    </div>
                    <div style={{borderRight:'1px solid #f6f7fb', paddingRight: '25px', paddingLeft: '25px'}}>
                      <p style={{fontSize:'12px'}}>WEIGHT </p>
                      <span className="counter">
                      <CountUp className="counter" end={item.weightSum} /></span>
                    </div>
                    <div style={{borderRight:'1px solid #f6f7fb', paddingRight: '25px', paddingLeft: '25px'}}>
                      <p style={{fontSize:'12px'}}>CATCHES </p>
                      <span className="counter">
                      <CountUp className="counter" end={item.count} /></span>
                    </div>
                  </div>
                </ListItemText>
                <ListItemSecondaryAction>
                  <ListItemText edge="end">
                    <h4 className={'text-center'}><CountUp className="counter " end={item.amount}/>{' '}</h4>{'POINTS'}
                  </ListItemText>
                </ListItemSecondaryAction>
              </ListItem>
            </div>
          )
        });

        this.setState({best: best});
      });
    }, 3000);

  }

  render() {

    const handleJoin = (e) => {
      if (localStorage.getItem(ACCESS_TOKEN)) {

      } else {
        alert('로그인 후 참가하실 수 있습니다.');
      }
    };

    function generate(element) {
      return [0, 1, 2].map((value) =>
        React.cloneElement(element, {
          key: value,
        }),
      );
      //accordianVertical
    }

    return (
      <div className="offset-lg-2 col-lg-8">
        <List>
          {/*<FlipMove*/}
          {/*  duration={700}*/}
          {/*  delay={10}*/}
          {/*  easing={{ value: '0.42,0.0,0.58,1.0',   label: 'ease' }}*/}
          {/*  staggerDurationBy={15}*/}
          {/*  staggerDelayBy={20}*/}
          {/*  leaveAnimation={'accordianVertical'}*/}
          {/*  enterAnimation={'accordianVertical'}*/}
          {/*>*/}
          {this.state.best}
          {/*</FlipMove>*/}
        </List>
      </div>
    );
  }
}

export default TournamentDetailLeaderboard;
